import { Inject, Injectable } from '@angular/core';
import { DOCUMENT }           from '@angular/common';

@Injectable({ providedIn: 'root' })
export class GtmService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  init(containerId: string): void {
    if (!containerId?.trim()) {
      console.warn('[GtmService] GTM container ID is missing or empty — GTM will not be loaded.');
      return;
    }

    // Bootstrap dataLayer before injecting the tag
    (window as any).dataLayer = (window as any).dataLayer || [];

    // Deduplication guard
    const existing = this.document.querySelector(`script[src*="${containerId}"]`);
    if (existing) return;

    try {
      this.injectScript(containerId);
      this.injectNoscript(containerId);
    } catch (error) {
      console.error('[GtmService] Failed to inject GTM tags:', error);
    }
  }

  private injectScript(id: string): void {
    const script   = this.document.createElement('script');
    script.async   = true;
    script.src     = `https://www.googletagmanager.com/gtm.js?id=${id}`;
    this.document.head.appendChild(script);
  }

  private injectNoscript(id: string): void {
    const noscript          = this.document.createElement('noscript');
    const iframe            = this.document.createElement('iframe');
    iframe.src              = `https://www.googletagmanager.com/ns.html?id=${id}`;
    iframe.height           = '0';
    iframe.width            = '0';
    iframe.style.display    = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    this.document.body.appendChild(noscript);
  }
}
